import { render, staticRenderFns } from "./UnfinishedStudentsDialog.vue?vue&type=template&id=b3ae4658&scoped=true"
import script from "./UnfinishedStudentsDialog.vue?vue&type=script&lang=js"
export * from "./UnfinishedStudentsDialog.vue?vue&type=script&lang=js"
import style0 from "./UnfinishedStudentsDialog.vue?vue&type=style&index=0&id=b3ae4658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ae4658",
  null
  
)

export default component.exports